var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fde048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffdf32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdcccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4e4e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cd9d25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebb93a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5252c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6151c"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v11.428571h-16z",
    fill: "url(#c)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.619048 0h8.380952v11.428571h-8.380952z",
    fill: "url(#a)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.2338899 6.11438124c.4463135-.44631348.4463135-1.1699306 0-1.61624407-.4463134-.44631348-1.1699306-.44631348-1.616244 0-.3518614.35186141-.4263249.87607581-.2233904 1.30088637l-1.6622278 1.66222776-.269374-.26937401-.2693739-.26937401-.53874807.53874802.26937402.269374.53874795.53874804.269374.26937402.2693741-.26937402 1.9316017-1.93160177c.4248106.20293452.949025.12847107 1.3008864-.22339033z",
    fill: "url(#d)",
    mask: "url(#g)",
    transform: "matrix(1 0 0 -1 0 12.70215)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.6860441 6.33777157c-.4248106.20293452-.94902498.12847107-1.30088639-.22339033-.44631352-.44631348-.44631352-1.1699306 0-1.61624407.44631345-.44631348 1.16993059-.44631348 1.61624409 0 .3518614.35186141.4263248.87607581.2233903 1.30088637l1.6622278 1.66222776.269374-.26937401.2693739-.26937401.5387481.53874802-.269374.269374-.538748.53874804-.269374.26937402-.269374-.26937402z",
    fill: "url(#e)",
    mask: "url(#g)",
    transform: "matrix(1 0 0 -1 0 12.70215)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.8095238 3.80952381c-.6311825 0-1.1428571-.17055819-1.1428571-.38095238s.5116746-.38095238 1.1428571-.38095238c.6311826 0 1.1428572.17055819 1.1428572.38095238s-.5116746.38095238-1.1428572.38095238zm0-1.90476191c-.3155913 0-.5714286-.08527909-.5714286-.19047619 0-.10519709.2558373-.19047619.5714286-.19047619s.5714286.0852791.5714286.19047619c0 .1051971-.2558373.19047619-.5714286.19047619zm0 .8888889c-.4207883 0-.7619048-.11370547-.7619048-.25396826s.3411165-.25396825.7619048-.25396825c.4207884 0 .7619048.11370546.7619048.25396825s-.3411164.25396826-.7619048.25396826z",
    fill: "url(#e)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.92431116 8.12046773c.06138134.18414408.18870284.4387872.40208074.69484061.3653459.43841501.8605038.70850118 1.4831319.70850118s1.1177861-.27008617 1.4831319-.70850118c.2133779-.25605341.3406994-.51069653.4020808-.69484061.0665325-.19959748-.041338-.41533843-.2409354-.48187085-.1995975-.06653253-.4153385.04133798-.4818709.24093539-.0338568.10157021-.1208209.27549851-.2645859.44801653-.2298923.2758707-.5204486.43435596-.8978205.43435596s-.6679282-.15848526-.8978205-.43435596c-.1437649-.17251802-.2307291-.34644632-.2645859-.44801653-.0665324-.19959741-.2822734-.30746792-.4818708-.24093539-.19959746.06653242-.30746793.28227337-.24093544.48187085z",
    fill: "url(#f)",
    mask: "url(#g)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVa);
export default __webpack_public_path__ + "static/media/VA.53e1526b2da6ce85daa84c55b04dca1b.svg";
export { ForwardRef as ReactComponent };